import React, { useMemo, useState } from "react";
import { StyledSwipeableDrawer, StyledTypography } from "../../../../../../styled-mui";
import MobileMenuWrapper from "../../MobileMenuWrapper";
import SmartLink from "../../../../../elements/smart-link/smart-link";
import { GetTopCategorySelector } from "../../../../../../redux/selectors/category";
import { useSelector } from "react-redux";
import { Box, Stack } from "@mui/material";
import { ImageLayout } from "../../../../../elements/image/ImageLayout";
import { CLICK } from "../../../../../../_foundation/constants/gtm";
import AsyncCall from "../../../../../../_foundation/gtm/async.service";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { HUBPROMO } from "../../../../../../constants/routes";
import { PromotionIcon } from "../../../../NavgationBarSvg";
import MobileProductsLevel2Menu from "./MobileProductsLevel2Menu";
import storeUtil from "../../../../../../utils/storeUtil";

interface Props {
  open: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu: () => any;
  menuLinksData: Record<string, any>;
}

const MobileProductsMenu: React.FC<Props> = ({ open, entireMenuCloseHandler, closeCurrentMenu, menuLinksData }) => {
  const topCategories = useSelector(GetTopCategorySelector);
  const [selectedLevelOneCat, setSelectedLevelOneCat] = useState<Record<string, any> | null>(null);
  const NAV_LEVEL_1 = "Produits";

  const filteredLinksByCatL1 = useMemo(() => {
    if (menuLinksData?.otherMenuLinks && selectedLevelOneCat?.identifier) {
      return menuLinksData.otherMenuLinks
        .filter((item: Record<string, any>) => item.categories?.includes(selectedLevelOneCat?.identifier))
        .flatMap(
          (item: Record<string, any>) =>
            item.links?.map((link) => ({
              label: link.label,
              url: link.url,
              target: link.target,
              type: link.type,
            })) || []
        );
    } else {
      return [];
    }
  }, [menuLinksData, selectedLevelOneCat]);

  const closeProduitsMenu = () => {
    setSelectedLevelOneCat(null);
    closeCurrentMenu();
  };

  const closeLevel2CategoryMenu = () => {
    setSelectedLevelOneCat(null);
  };

  const onCatItemClick = (catItem: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: catItem?.name || "",
      nav_level_3: "",
      nav_type: "cta",
      btn_label: catItem?.name || "",
      click_destination: "",
    });
    setSelectedLevelOneCat(catItem || null); // enables level two category menu
  };

  const onGoodDealsClick = () => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "",
      nav_level_3: "",
      nav_type: "promo_block",
      btn_label: "Voir les bonnes affaires",
      click_destination: HUBPROMO,
    });
    entireMenuCloseHandler();
  };

  return (
    <>
      <StyledSwipeableDrawer
        anchor="left"
        open={open}
        onClose={closeProduitsMenu}
        onOpen={() => null}
        className="child-drawer header-menu-level2 mobile-produits-level1-menu">
        <MobileMenuWrapper
          title="Produits"
          isASubMenu
          entireMenuCloseHandler={entireMenuCloseHandler}
          closeCurrentMenu={closeProduitsMenu}>
          {topCategories &&
            topCategories?.map((catItem: Record<string, any>, index: number) => (
              <Box
                key={catItem?.identifier}
                onClick={() => onCatItemClick(catItem)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "16px 12px",
                  borderBottom: "1px solid rgba(0, 0, 0, 0.11)",
                }}>
                <ImageLayout
                  src={storeUtil.getUrlPicture(`img/contrib/categories/icons/${catItem?.identifier}.svg`, "")}
                  height={24}
                  width={24}
                  styles={{ margin: "unset" }}
                />
                <Stack direction="row" justifyContent="space-between" width="100%">
                  <StyledTypography
                    variant="body1"
                    component="p"
                    style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                    {catItem?.name || ""}
                  </StyledTypography>
                  <ChevronRightIcon sx={{ fontSize: "20px", color: "black" }} />
                </Stack>
              </Box>
            ))}
          <SmartLink
            onClick={() => onGoodDealsClick()}
            to={HUBPROMO}
            styles={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "16px 12px",
              borderBottom: "1px solid rgba(0, 0, 0, 0.11)",
            }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
              }}>
              <PromotionIcon />
            </Box>
            <StyledTypography
              variant="body1"
              component="p"
              style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px", color: "rgb(196, 30, 59)" }}>
              Voir les bonnes affaires
            </StyledTypography>
          </SmartLink>
        </MobileMenuWrapper>
      </StyledSwipeableDrawer>

      {/* LEVEL 2 CATEGORY PAGE, using "open" state to prevent unnecessary DOM size */}
      {open && (
        <MobileProductsLevel2Menu
          levelOneCat={selectedLevelOneCat}
          open={selectedLevelOneCat !== null}
          entireMenuCloseHandler={entireMenuCloseHandler}
          closeCurrentMenu={closeLevel2CategoryMenu}
          filteredLinksByCatL1={filteredLinksByCatL1}
        />
      )}
    </>
  );
};

export default MobileProductsMenu;
